export { default as CenteredLogo } from './CenteredLogo';
